module.exports = __webpack_public_path__ + "static/media/plan60.b62e139e.pdf";